/**
 * Canonical documentation base URL.
 *
 * Single source of truth for the public docs site. Used by the sidebar/footer
 * nav and by every "how it works" info modal's "Read docs" footer link.
 * Deep-link paths (e.g. /markets/resolution) can be appended per surface once
 * the docs information architecture is finalised.
 */
export const DOCS_URL = 'https://docs.morfi.markets';
